export function apiGetBaseUrl() {
  if (window.__ENV__?.API_BASE_URL) {
    return window.__ENV__.API_BASE_URL
  }

  const urlProtocol = `${document.location.protocol}//`
  const baseHostname = document.location.hostname.replace(/^app\./, '')
  return urlProtocol + baseHostname
}
